import { render, staticRenderFns } from "./SubscriptionQrViewer.vue?vue&type=template&id=b0958f38&scoped=true&"
import script from "./SubscriptionQrViewer.vue?vue&type=script&lang=js&"
export * from "./SubscriptionQrViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0958f38",
  null
  
)

/* custom blocks */
import block0 from "./SubscriptionQrViewer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/render/project/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
